import React, {Component} from 'react';

import './MobileNavMenu.css';

class MobileNavMenu extends Component {
    render() {
        return(
            <div className={localStorage.getItem("user_has_hair_profile") && !localStorage.getItem("user_has_skin_profile") ? "mobile-nav-menu no-banner" : !this.props.active ? "mobile-nav-menu" : "mobile-nav-menu is-active"} onClick={this.props.handleOnClick}>
                <span className="menu-box">
                    <span className="menu-line">
                    </span>
                </span>
            </div>
        );
    }
}
export default MobileNavMenu;



// WEBPACK FOOTER //
// ./src/components/header/MobileNavMenu.js